import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import translateMapsServices from '@src/services/translateMaps.services';

export const langaugeUpdate = createAsyncThunk(
  'admin/langaugeUpdate',
  async ({ body }, { rejectWithValue }) => {
    try {
      const result = await translateMapsServices.languageUpdate(body);
      return result;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const languagesGetPagedList = createAsyncThunk(
  'admin/languagesGetPagedList',
  async ({ body, pageNumber, pageSize }, { rejectWithValue, dispatch }) => {
    try {
      const result = await translateMapsServices.getPagedList({ body, pageNumber, pageSize });
      dispatch(setFilterObject(body));
      return result;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const languagesUpdatedRedis = createAsyncThunk(
  'admin/languagesUpdatedRedis',
  async ({ rejectWithValue }) => {
    try {
      const result = await translateMapsServices.languageUpdateRedis();
      return result;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  langaugesList: [],
  tableProperty: {
    currentPage: 1,
    page: 1,
    pageSize: 10,
    totalCount: 0,
  },
  filterObject: {
    body: [],
    pageNumber: 1,
    pageSize: 10,
  },
};

export const managementLanguagesSlice = createSlice({
  name: 'admin/managementLanguages',
  initialState,
  reducers: {
    setFilterObject: (state, action) => {
      state.filterObject.body = action.payload;
    },
    clearFilterObject(state) {
      state.filterObject = { ...state.filterObject };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(languagesGetPagedList.fulfilled, (state, action) => {
      state.langaugesList = action?.payload?.data?.items || [];
      state.tableProperty = action?.payload?.data?.pagedProperty || initialState?.tableProperty;
    });
  },
});

export const { setFilterObject, clearFilterObject } = managementLanguagesSlice.actions;
